(() => {
  'use strict';

  const media = window.matchMedia('(max-width: 741px)');
  const saved = new WeakMap();
  let frame;
  let observer;

  function restore(grid, state) {
    if (!state) return;
    state.moves.slice().reverse().forEach(({ promo, product }) => {
      if (promo.parentElement === grid && product.parentElement === grid) {
        promo.after(product);
      }
    });
  }

  function arrange(grid) {
    const previous = saved.get(grid);
    const current = Array.from(grid.children);
    const columns = getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length;
    const active = media.matches && columns === 2 && !!grid.querySelector('.collection-promo-tile .standard-discount-comparison');
    if (previous && previous.active === active && previous.children.length === current.length &&
        previous.children.every((child, index) => child === current[index])) return;

    restore(grid, previous);
    const moves = [];
    if (active) {
      const items = Array.from(grid.children).filter(item => getComputedStyle(item).display !== 'none');
      const firstTile = items.find(item => item.classList.contains('collection-promo-tile') &&
        item.querySelector('.standard-discount-comparison'));
      if (firstTile && getComputedStyle(firstTile).gridColumnEnd === 'auto') {
        let occupied = 0;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (!item.classList.contains('product-item')) continue;
          if (item.classList.contains('collection-promo-tile') && item !== firstTile) {
            const style = getComputedStyle(item);
            const fullWidth = style.gridColumnEnd === '-1' || style.gridColumnEnd === 'span 2';
            if (!fullWidth) {
              occupied += 1;
              continue;
            }
            const next = items[i + 1];
            if (occupied % 2 === 1 && next && next.classList.contains('product-item') &&
                !next.classList.contains('collection-promo-tile')) {
              grid.insertBefore(next, item);
              moves.push({ promo: item, product: next });
              i += 1;
            }
            occupied = 0;
          } else {
            occupied += 1;
          }
        }
      }
    }
    saved.set(grid, { active, moves, children: Array.from(grid.children) });
  }

  function refresh() {
    frame = null;
    if (observer) observer.disconnect();
    document.querySelectorAll('.product-list__inner').forEach(arrange);
    const main = document.getElementById('main');
    if (observer && main) observer.observe(main, { childList: true, subtree: true });
  }

  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(refresh);
  }

  function init() {
    observer = new MutationObserver(schedule);
    media.addEventListener('change', schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:reorder', schedule);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
